import { io } from 'socket.io-client';
import { auth } from '../firebaseConfig';

let socket = null;
let reconnectAttempts = 0;
const MAX_RECONNECT_ATTEMPTS = 5;
const RECONNECT_DELAY = 1000;

const initializeSocket = () => {
  const apiUrl = import.meta.env.VITE_API_URL || 'http://localhost:5051';
  
  socket = io(apiUrl, {
    autoConnect: false,
    transports: ['websocket', 'polling'],
    reconnection: true,
    reconnectionAttempts: MAX_RECONNECT_ATTEMPTS,
    reconnectionDelay: RECONNECT_DELAY,
    timeout: 10000
  });

  // Connection event handlers
  socket.on('connect', () => {
    console.log('🔌 Socket.io connected');
    reconnectAttempts = 0;
    
    // Store socket globally for components to use
    window.socket = socket;
  });

  socket.on('disconnect', (reason) => {
    console.log('🔌 Socket.io disconnected:', reason);
    window.socket = null;
    
    if (reason === 'io server disconnect') {
      // Server initiated disconnect, reconnect manually
      socket.connect();
    }
  });

  socket.on('connect_error', (error) => {
    console.error('🔌 Socket.io connection error:', error);
    reconnectAttempts++;
    
    if (reconnectAttempts >= MAX_RECONNECT_ATTEMPTS) {
      console.error('🔌 Max reconnection attempts reached');
    }
  });

  // Authentication
  socket.on('connect', async () => {
    try {
      const user = auth.currentUser;
      if (user) {
        const token = await user.getIdToken();
        socket.auth = { token };
        
        // Reconnect with authentication
        if (socket.recovered) {
          return;
        }
        socket.disconnect().connect();
      }
    } catch (error) {
      console.error('Socket authentication error:', error);
    }
  });

  return socket;
};

const connectSocket = () => {
  if (!socket) {
    initializeSocket();
  }
  
  if (!socket.connected) {
    socket.connect();
  }
  
  return socket;
};

const disconnectSocket = () => {
  if (socket) {
    socket.disconnect();
    socket = null;
    window.socket = null;
  }
};

// Join specific item room for real-time updates
const joinItemRoom = (itemId, itemType) => {
  if (socket && socket.connected) {
    socket.emit('join_item', { itemId, itemType });
  }
};

// Leave specific item room
const leaveItemRoom = (itemId, itemType) => {
  if (socket && socket.connected) {
    socket.emit('leave_item', { itemId, itemType });
  }
};

// Get current socket instance
const getSocket = () => socket;

// Check if socket is connected
const isConnected = () => socket && socket.connected;

export {
  initializeSocket,
  connectSocket,
  disconnectSocket,
  joinItemRoom,
  leaveItemRoom,
  getSocket,
  isConnected
}; 